import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { StorageHelper } from '../helpers/StorageHelper';
import { HealthService } from '../health.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-server-down',
  templateUrl: './server-down.component.html',
  styleUrls: ['./server-down.component.scss'],
  providers: [ HealthService ]
})
export class ServerDownComponent extends BaseComponent implements OnInit {

  constructor(
    private healthService: HealthService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.healthService.getWebsiteHealth().subscribe(res => {
      if(res && res['showDownScreen'] == "0") {
        //The server is down not down, redirect to the home page
        this.router.navigate(['']);
      }
    }, err => {

    });
  }

  getMessage(): string {
    let serverMessage: string = StorageHelper.getInstance().get(StorageHelper.keys.downScreenMessage);
    if(serverMessage) {
      return serverMessage;
    }
    else {
      return this.getString('cheapchartsCurrentlyUnavailable');
    }
  }

}
